var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g2, _g3, _g4, _path44, _path45, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareProgramWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 287,
    viewBox: "0 0 272 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.72217,
    width: 264.072,
    height: 286.078,
    rx: 10.8,
    fill: "#F2F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.319 82.0283H71.4453C68.3437 82.0283 65.8293 84.5427 65.8293 87.6443V131.762C65.8293 134.864 68.3437 137.378 71.4453 137.378H251.319C254.421 137.378 256.935 134.864 256.935 131.762V87.6443C256.935 84.5427 254.421 82.0283 251.319 82.0283Z",
    fill: "#D8E5E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 95.1826H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 102.472H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 109.752H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 116.988H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 124.223H149.13",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.564 96.3814C99.7748 96.3814 100.756 95.3998 100.756 94.189C100.756 92.9782 99.7748 91.9966 98.564 91.9966C97.3532 91.9966 96.3716 92.9782 96.3716 94.189C96.3716 95.3998 97.3532 96.3814 98.564 96.3814Z",
    fill: "#F69159"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.582 118.057C102.657 117.852 102.603 117.614 102.452 117.452C101.21 116.08 100.281 112.851 102.236 107.214C104.331 101.209 102.387 97.4611 97.9593 95.9275C93.5313 94.3939 89.6865 96.1111 87.6021 102.127C85.6473 107.764 82.9149 109.719 81.0789 110.022C80.8629 110.054 80.6793 110.205 80.6037 110.41V110.432C80.4849 110.745 80.6577 111.08 80.9601 111.188L101.804 118.435C102.117 118.543 102.452 118.381 102.56 118.068V118.046L102.582 118.057Z",
    fill: "#FFCC66"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8533 119.72C97.5711 119.72 98.9637 118.328 98.9637 116.61C98.9637 114.892 97.5711 113.5 95.8533 113.5C94.1355 113.5 92.7429 114.892 92.7429 116.61C92.7429 118.328 94.1355 119.72 95.8533 119.72Z",
    fill: "#FFCC66"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0897 110.022C80.8737 110.054 80.6901 110.205 80.6145 110.411V110.432C80.4957 110.745 80.6685 111.08 80.9709 111.188L101.815 118.435C102.128 118.543 102.463 118.381 102.571 118.068V118.046C102.646 117.841 102.592 117.603 102.452 117.441C101.901 116.826 101.404 115.843 101.199 114.45L83.9193 108.445C82.8933 109.417 81.8997 109.881 81.0789 110.022H81.0897Z",
    fill: "#F69159"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.275 124.083C101.124 124.083 100.973 123.997 100.908 123.846C100.811 123.641 100.908 123.403 101.102 123.306C105.109 121.416 106.718 116.372 104.688 112.074C104.591 111.869 104.688 111.631 104.882 111.534C105.087 111.437 105.325 111.534 105.422 111.728C107.647 116.437 105.865 121.956 101.448 124.04C101.394 124.062 101.329 124.083 101.275 124.083Z",
    fill: "#48C1BC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9684 116.372C77.8172 116.372 77.666 116.286 77.6012 116.135C76.532 113.856 76.3484 111.329 77.0936 109.007C77.8388 106.674 79.4372 104.838 81.5756 103.823C81.7808 103.726 82.0184 103.823 82.1156 104.017C82.2128 104.212 82.1156 104.46 81.9212 104.557C79.988 105.475 78.5408 107.138 77.8712 109.255C77.1908 111.383 77.3528 113.694 78.3464 115.789C78.4436 115.994 78.3464 116.232 78.152 116.329C78.098 116.351 78.0332 116.372 77.9792 116.372H77.9684Z",
    fill: "#48C1BC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.305 127.41C103.143 127.41 102.981 127.313 102.906 127.151C102.798 126.924 102.906 126.665 103.122 126.557C105.832 125.272 107.852 122.939 108.802 119.98C109.753 117.01 109.526 113.77 108.144 110.843C108.036 110.616 108.144 110.357 108.36 110.249C108.586 110.141 108.846 110.249 108.954 110.465C110.433 113.586 110.682 117.064 109.656 120.25C108.63 123.447 106.448 125.974 103.51 127.356C103.446 127.389 103.381 127.399 103.316 127.399L103.305 127.41Z",
    fill: "#48C1BC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4908 117.647C74.3288 117.647 74.1668 117.55 74.0912 117.388C72.6116 114.266 72.3632 110.789 73.3892 107.603C74.4152 104.406 76.5968 101.879 79.5344 100.496C79.7612 100.388 80.0204 100.496 80.1284 100.712C80.2364 100.928 80.1284 101.198 79.9124 101.306C77.2016 102.592 75.182 104.924 74.2316 107.884C73.2812 110.854 73.508 114.094 74.8904 117.02C74.9984 117.247 74.8904 117.506 74.6744 117.614C74.6096 117.647 74.5448 117.658 74.48 117.658L74.4908 117.647Z",
    fill: "#48C1BC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M251.319 146.029H71.4453C68.3437 146.029 65.8293 148.543 65.8293 151.645V195.763C65.8293 198.865 68.3437 201.379 71.4453 201.379H251.319C254.421 201.379 256.935 198.865 256.935 195.763V151.645C256.935 148.543 254.421 146.029 251.319 146.029Z",
    fill: "#D8E5E9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 159.183H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 166.462H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 173.752H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 180.988H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 188.224H232.419",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8183 156.008H97.7219C98.4563 156.008 99.0503 156.602 99.0503 157.336V162.002H86.5007V157.336C86.5007 156.602 87.0947 156.008 87.8291 156.008H87.8183Z",
    fill: "#F4F8FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M97.225 160.577H88.3258C85.9757 160.577 84.0706 162.482 84.0706 164.832V187.134C84.0706 189.484 85.9757 191.389 88.3258 191.389H97.225C99.575 191.389 101.48 189.484 101.48 187.134V164.832C101.48 162.482 99.575 160.577 97.225 160.577Z",
    fill: "#F6915A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.545 165.145H90.7019V185.978H101.545V165.145Z",
    fill: "#F4F8FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M251.319 210.019H71.4453C68.3437 210.019 65.8293 212.534 65.8293 215.635V259.753C65.8293 262.855 68.3437 265.369 71.4453 265.369H251.319C254.421 265.369 256.935 262.855 256.935 259.753V215.635C256.935 212.534 254.421 210.019 251.319 210.019Z",
    fill: "#D8E5E9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 223.173H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 230.452H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 237.742H243.889",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 244.978H200.57",
    stroke: "#1B566B",
    strokeWidth: 2.6244,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251.319 18.0386H71.4453C68.3437 18.0386 65.8293 20.5529 65.8293 23.6546V67.7726C65.8293 70.8742 68.3437 73.3886 71.4453 73.3886H251.319C254.421 73.3886 256.935 70.8742 256.935 67.7726V23.6546C256.935 20.5529 254.421 18.0386 251.319 18.0386Z",
    fill: "#D8E5E9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M95.216 64.0252C105.332 64.0252 113.533 55.8245 113.533 45.7084C113.533 35.5923 105.332 27.3916 95.216 27.3916C85.0999 27.3916 76.8992 35.5923 76.8992 45.7084C76.8992 55.8245 85.0999 64.0252 95.216 64.0252Z",
    fill: "#0383A4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 35.2539H175.903",
    stroke: "#1B566B",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 45.7085H194.036",
    stroke: "#1B566B",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.356 56.1738H158.234",
    stroke: "#1B566B",
    strokeWidth: 2.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9206_31176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 76,
    y: 27,
    width: 38,
    height: 38
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M95.216 64.0252C105.332 64.0252 113.533 55.8245 113.533 45.7084C113.533 35.5923 105.332 27.3916 95.216 27.3916C85.0999 27.3916 76.8992 35.5923 76.8992 45.7084C76.8992 55.8245 85.0999 64.0252 95.216 64.0252Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9206_31176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1704 52.2533L92.8184 43.9373L100.195 45.5141L99.5468 52.9985C104.277 56.9837 101.761 59.2301 101.761 63.5933L89.9672 63.4313C89.9672 59.0681 88.7144 54.7805 92.1596 52.2533H92.1704Z",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8784 53.4414C88.9952 52.9338 91.2416 52.4154 92.1812 52.2534L95.7776 61.3686L99.5684 52.9986C100.087 53.2038 100.638 53.3766 101.188 53.5278C105.001 54.6078 107.938 57.6318 108.986 61.4442L112.248 73.4106C112.248 73.4106 73.3352 73.7454 73.3352 70.311C73.3352 69.609 77.1476 63.0966 79.7828 58.6686C81.3488 56.0334 83.9192 54.1542 86.9 53.4414H86.8784Z",
    fill: "#47C2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9178 32.8135L90.097 33.6667C89.881 33.8935 89.7622 34.1959 89.7622 34.5091V38.0299L92.7754 34.1311L90.9178 32.8135Z",
    fill: "#3B3F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.897 42.0583C101.016 47.0587 98.2511 51.1843 95.0651 51.2599C91.8791 51.3355 88.9307 47.3395 88.8227 42.3391C88.7147 37.3387 90.6371 33.7315 94.6655 33.6451C98.6939 33.5587 100.789 37.0579 100.897 42.0691V42.0583Z",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1751 44.2615C93.1751 44.2615 93.1427 44.2615 93.1211 44.2615C93.0887 44.2507 92.2355 43.9699 91.9331 43.3759C91.6415 42.8143 92.3003 40.0279 92.4299 39.4771C92.4515 39.3907 92.5379 39.3367 92.6351 39.3583C92.7215 39.3799 92.7755 39.4663 92.7539 39.5635C92.4299 40.8811 92.0519 42.9007 92.2247 43.2355C92.4191 43.6243 93.0023 43.8835 93.2075 43.9591C93.2939 43.9915 93.3479 44.0779 93.3155 44.1751C93.2939 44.2507 93.2291 44.2939 93.1535 44.2939L93.1751 44.2615Z",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.109 46.7025C101.232 45.0933 101.869 42.1017 101.988 39.8337C102.161 36.7449 103.327 34.0449 98.9097 33.1485C97.9917 32.9649 97.0521 33.9261 95.7561 33.7101C101.34 35.0817 98.6613 39.0237 98.6613 39.0237C98.6613 39.0237 99.6441 43.2465 100.098 46.7025H100.109Z",
    fill: "#3B3F41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3478 35.2432C91.9438 34.7032 91.5334 34.228 90.2482 32.608C90.0646 32.3704 90.2266 32.0248 90.529 32.0248C95.173 32.0032 98.1646 31.8628 100.908 34.1308C102.841 35.7292 99.6874 33.3208 93.3478 35.2324V35.2432Z",
    fill: "#3B3F41"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M105.476 217.903H78.1735C76.9268 217.903 75.9163 218.914 75.9163 220.16V255.217C75.9163 256.464 76.9268 257.474 78.1735 257.474H105.476C106.722 257.474 107.733 256.464 107.733 255.217V220.16C107.733 218.914 106.722 217.903 105.476 217.903Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9206_31176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 219,
    width: 34,
    height: 38
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M104.364 219.372H79.2752C77.2591 219.372 75.6248 221.006 75.6248 223.022V252.355C75.6248 254.371 77.2591 256.006 79.2752 256.006H104.364C106.38 256.006 108.014 254.371 108.014 252.355V223.022C108.014 221.006 106.38 219.372 104.364 219.372Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9206_31176)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M103.014 241.285H81.0787C80.8627 241.285 80.6899 241.112 80.6899 240.896C80.6899 240.68 80.8627 240.508 81.0787 240.508H103.003C103.219 240.508 103.392 240.68 103.392 240.896C103.392 241.112 103.219 241.285 103.003 241.285H103.014Z",
    fill: "#D8E5E9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M103.014 243.294H81.0787C80.8627 243.294 80.6899 243.122 80.6899 242.906C80.6899 242.69 80.8627 242.517 81.0787 242.517H103.003C103.219 242.517 103.392 242.69 103.392 242.906C103.392 243.122 103.219 243.294 103.003 243.294H103.014Z",
    fill: "#D8E5E9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M102.052 245.292H81.0787C80.8627 245.292 80.6899 245.119 80.6899 244.903C80.6899 244.687 80.8627 244.514 81.0787 244.514H102.052C102.268 244.514 102.441 244.687 102.441 244.903C102.441 245.119 102.268 245.292 102.052 245.292Z",
    fill: "#D8E5E9"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M102.052 249.623H81.0787C80.8627 249.623 80.6899 249.45 80.6899 249.234C80.6899 249.018 80.8627 248.845 81.0787 248.845H102.052C102.268 248.845 102.441 249.018 102.441 249.234C102.441 249.45 102.268 249.623 102.052 249.623Z",
    fill: "#D8E5E9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M103.014 235.529H81.0787C80.8627 235.529 80.6899 235.357 80.6899 235.141C80.6899 234.925 80.8627 234.752 81.0787 234.752H103.003C103.219 234.752 103.392 234.925 103.392 235.141C103.392 235.357 103.219 235.529 103.003 235.529H103.014Z",
    fill: "#D8E5E9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9283 237.538H81.0787C80.8627 237.538 80.6899 237.366 80.6899 237.15C80.6899 236.934 80.8627 236.761 81.0787 236.761H90.9283C91.1443 236.761 91.3171 236.934 91.3171 237.15C91.3171 237.366 91.1443 237.538 90.9283 237.538Z",
    fill: "#D8E5E9"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M103.392 223.617H91.436V232.483H103.392V223.617Z",
    fill: "#FFCC66"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9206_31176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.055 35.3184H29.1094V57.264H51.055V35.3184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1058 52.2095C37.771 52.2095 37.4578 52.0583 37.2418 51.7991L32.1982 45.7079C31.7986 45.2327 31.8634 44.5199 32.3494 44.1203C32.8246 43.7207 33.5374 43.7855 33.937 44.2715L37.9114 49.0667C39.5962 46.1507 44.035 39.7679 52.3186 35.4479C52.8694 35.1563 53.5498 35.3723 53.8414 35.9231C54.133 36.4739 53.917 37.1543 53.3662 37.4459C43.279 42.7055 39.175 51.4643 39.1318 51.5507C38.9698 51.9071 38.635 52.1447 38.257 52.1987C38.203 52.1987 38.1598 52.1987 38.1058 52.1987V52.2095Z",
    fill: "#EF5489"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9206_31176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.055 100.119H29.1094V122.064H51.055V100.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1058 117.01C37.771 117.01 37.4578 116.858 37.2418 116.599L32.1982 110.508C31.7986 110.033 31.8634 109.32 32.3494 108.92C32.8246 108.521 33.5374 108.586 33.937 109.072L37.9114 113.867C39.5962 110.951 44.035 104.568 52.3186 100.248C52.8694 99.9564 53.5498 100.172 53.8414 100.723C54.133 101.274 53.917 101.954 53.3662 102.246C43.279 107.506 39.175 116.264 39.1318 116.351C38.9698 116.707 38.635 116.945 38.257 116.999C38.203 116.999 38.1598 116.999 38.1058 116.999V117.01Z",
    fill: "#EF5489"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9206_31176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.055 164.919H29.1094V186.864H51.055V164.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1058 181.81C37.771 181.81 37.4578 181.659 37.2418 181.399L32.1982 175.308C31.7986 174.833 31.8634 174.12 32.3494 173.721C32.8246 173.321 33.5374 173.386 33.937 173.872L37.9114 178.667C39.5962 175.751 44.035 169.368 52.3186 165.048C52.8694 164.757 53.5498 164.973 53.8414 165.523C54.133 166.074 53.917 166.755 53.3662 167.046C43.279 172.306 39.175 181.065 39.1318 181.151C38.9698 181.507 38.635 181.745 38.257 181.799C38.203 181.799 38.1598 181.799 38.1058 181.799V181.81Z",
    fill: "#EF5489"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M51.055 229.719H29.1094V251.664H51.055V229.719Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M38.106 246.61C37.7712 246.61 37.458 246.458 37.242 246.199L32.1984 240.108C31.7988 239.633 31.8636 238.92 32.3496 238.52C32.8248 238.121 33.5376 238.186 33.9372 238.672L37.9116 243.467C39.5964 240.551 44.0352 234.168 52.3188 229.848C52.8696 229.556 53.55 229.772 53.8416 230.323C54.1332 230.874 53.9172 231.554 53.3664 231.846C43.2792 237.106 39.1752 245.864 39.132 245.951C38.97 246.307 38.6352 246.545 38.2572 246.599C38.2032 246.599 38.16 246.599 38.106 246.599V246.61Z",
    fill: "#EF5489"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9206_31176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8616,
    height: 21.9456,
    fill: "white",
    transform: "translate(29.1094 35.3184)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9206_31176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8616,
    height: 21.9456,
    fill: "white",
    transform: "translate(29.1094 100.119)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9206_31176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.8616,
    height: 21.9456,
    fill: "white",
    transform: "translate(29.1094 164.919)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareProgramWelcome);
export default __webpack_public_path__ + "static/media/CareProgramWelcome.d12cadeb64681c7ce57cc474de59d46c.svg";
export { ForwardRef as ReactComponent };